import * as React from "react"

import { cn } from "@/components/utils/utils"

interface InputProps extends React.ComponentProps<"input"> {
  hasError?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, hasError = false, readOnly, ...props }, ref) => {
    return (
      <input
        type={type}
        readOnly={readOnly}
        className={cn(
          "flex h-10 w-full rounded-md border bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:",
          hasError ? "border-yellow-400" : "border-input",
          // Sola lettura: nessun box/bordo, il campo si legge come testo semplice
          // invece di apparire come un input compilabile.
          readOnly && "border-transparent bg-transparent px-0 shadow-none cursor-default focus-visible:ring-0",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
